const STOREFRONT_TOKEN = 'fad030faa4c018ac0fb647ca62e92e50';
const SHOP_DOMAIN = 'casapampa.cl';
const endpoint = `https://${SHOP_DOMAIN}/api/2025-01/graphql.json`;
const CACHE_TTL = 60 * 60 * 1000; // 1 hora en ms

const fmt = (n) => new Intl.NumberFormat('es-CL', {
  style: 'currency', currency: 'CLP', maximumFractionDigits: 0
}).format(n);

function getCached(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { value, expires } = JSON.parse(raw);
    if (Date.now() > expires) { localStorage.removeItem(key); return null; }
    return value;
  } catch { return null; }
}

function setCache(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify({ value, expires: Date.now() + CACHE_TTL }));
  } catch {}
}

// ── PÁGINA DE PRODUCTO ──────────────────────────────────────────
async function fetchDiscountedPrice(variantId) {
  const cacheKey = `dp_${variantId}`;
  const cached = getCached(cacheKey);
  if (cached) { renderDiscount(cached); return; }

  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: `mutation {
          cartCreate(input: { lines: [{ quantity: 1, merchandiseId: "gid://shopify/ProductVariant/${variantId}" }] }) {
            cart {
              lines(first: 1) {
                edges {
                  node {
                    cost { totalAmount { amount } }
                    discountAllocations { discountedAmount { amount } }
                  }
                }
              }
            }
          }
        }`
      })
    });
    const data = await res.json();
    const node = data?.data?.cartCreate?.cart?.lines?.edges?.[0]?.node;
    if (!node) return;

    const discountTotal = node.discountAllocations.reduce(
      (sum, d) => sum + parseFloat(d.discountedAmount.amount), 0
    );
    if (discountTotal <= 0) return;

    const discounted = parseFloat(node.cost.totalAmount.amount);
    const original = discounted + discountTotal;
    const result = { discounted, original, pct: Math.round((discountTotal / original) * 100) };

    setCache(cacheKey, result);
    renderDiscount(result);
  } catch (e) { console.warn('PDP discount preview error:', e); }
}

function renderDiscount({ discounted, original, pct }) {
  const pdpEl = document.getElementById('discount-preview');
  if (pdpEl) pdpEl.style.display = 'none';

  const priceContainers = document.querySelectorAll('.price:not([data-discount-applied])');
  priceContainers.forEach(container => {
    container.dataset.discountApplied = 'true';

    const regularItem = container.querySelector('.price__regular .price-item--regular bdi, .price__regular .price-item--regular');
    if (regularItem) regularItem.textContent = fmt(discounted);

    const saleItem = container.querySelector('.price__sale .price-item--sale bdi');
    if (saleItem) saleItem.textContent = fmt(discounted);

    const compareRegular = container.querySelector('.price__compare .price-item--regular bdi, .price__compare .price-item--regular');
    if (compareRegular) compareRegular.textContent = fmt(original);

    const salePrice = container.querySelector('.price__sale .price-item--sale');
    if (salePrice) salePrice.style.color = '#992525';

    container.classList.add('price--on-sale');
  });
}

// ── PÁGINA DE COLECCIÓN ─────────────────────────────────────────
async function processBatch(variantIds) {
  const uncached = variantIds.filter(id => !getCached(`dp_${id}`));

  variantIds.forEach(id => {
    const cached = getCached(`dp_${id}`);
    if (cached) applyCardDiscount(id, cached);
  });

  if (uncached.length === 0) return;

  const lines = uncached.map(id =>
    `{ quantity: 1, merchandiseId: "gid://shopify/ProductVariant/${id}" }`
  ).join(', ');

  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: `mutation {
          cartCreate(input: { lines: [${lines}] }) {
            cart {
              lines(first: 10) {
                edges {
                  node {
                    merchandise { ... on ProductVariant { id } }
                    cost { totalAmount { amount } }
                    discountAllocations { discountedAmount { amount } }
                  }
                }
              }
            }
          }
        }`
      })
    });
    const data = await res.json();
    const lines_result = data?.data?.cartCreate?.cart?.lines?.edges;
    if (!lines_result) return;

    lines_result.forEach(({ node }) => {
      const variantId = node.merchandise.id.split('/').pop();
      const discountTotal = node.discountAllocations.reduce(
        (sum, d) => sum + parseFloat(d.discountedAmount.amount), 0
      );
      if (discountTotal <= 0) return;

      const discounted = parseFloat(node.cost.totalAmount.amount);
      const original = discounted + discountTotal;
      const result = { discounted, original, pct: Math.round((discountTotal / original) * 100) };

      setCache(`dp_${variantId}`, result);
      applyCardDiscount(variantId, result);
    });
  } catch (e) { console.warn('Collection discount batch error:', e); }
}

function applyCardDiscount(variantId, { discounted, original, pct }) {
  document.querySelectorAll(`[data-variant-id="${variantId}"]`).forEach(card => {
    const priceEl = card.querySelector('.price__regular .price-item--regular');
    if (!priceEl || card.dataset.discountApplied) return;
    card.dataset.discountApplied = 'true';

    const bdi = priceEl.querySelector('bdi');
    if (bdi) bdi.textContent = fmt(discounted);
    else priceEl.textContent = fmt(discounted);

    const badge = document.createElement('span');
    badge.style.cssText = 'background:#992525;color:#fff;padding:2px 6px;border-radius:0;font-weight:bold;font-size:12px;margin-left:6px;';

    badge.textContent = `-${pct}%`;
    priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);

    const origEl = document.createElement('s');
    origEl.style.cssText = 'color:#999;font-size:12px;display:block;';
    origEl.textContent = fmt(original);
    priceEl.parentNode.insertBefore(origEl, badge.nextSibling);
  });
}

async function fetchCollectionDiscounts() {
  const cards = document.querySelectorAll('[data-variant-id]');
  if (cards.length === 0) return;

  const variantIds = [...new Set([...cards].map(c => c.dataset.variantId).filter(Boolean))];
  const BATCH_SIZE = 5;

  for (let i = 0; i < variantIds.length; i += BATCH_SIZE) {
    const batch = variantIds.slice(i, i + BATCH_SIZE);
    await processBatch(batch);
    if (i + BATCH_SIZE < variantIds.length) await new Promise(r => setTimeout(r, 600));
  }
}

// ── INIT ────────────────────────────────────────────────────────
let discountTimeout = null;

function scheduleCollectionUpdate() {
  clearTimeout(discountTimeout);
  discountTimeout = setTimeout(fetchCollectionDiscounts, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  const pdpEl = document.getElementById('discount-preview');
  if (pdpEl) fetchDiscountedPrice(pdpEl.dataset.variantId);

  if (document.querySelectorAll('[data-variant-id]').length > 0) {
    fetchCollectionDiscounts();

    const grid = document.querySelector('.collection, .product-grid, [data-id="main-collection-product-grid"]');
    if (grid) {
      const observer = new MutationObserver(scheduleCollectionUpdate);
      observer.observe(grid, { childList: true, subtree: true });
    }
  }
});

document.addEventListener('variant:change', (e) => {
  if (e.detail?.variant?.id) fetchDiscountedPrice(e.detail.variant.id);
});
